export default ({...props}) => {
  const {size, themeGrey, space} = props.theme
  return `
        cursor: pointer;
        font-size:${size(2)}px;
        &:focus,
        &:active,
        &:hover{
            background:none;
        }
        &[ap_atom_name="buttonPrevnextAtom"]{
            display: flex;
            gap: ${space(0.625)}px;
            min-width: auto;
            max-width:${size(6.25)}px;
            padding: 0;
            align-items: flex-start;
        }
        [ap_atom_name="svgIconAtom"] {
            width: ${size(1.25)}px;
            height: ${size(2)}px;
            display: -webkit-box;
            > svg {
                width: ${size(12.5)}%;
              }
        }
        .MuiTypography-root{
            position: relative;
            margin: 0;
        }
        &[disabled]{
            & * {
                color: ${themeGrey.disabled_grey};
            }
            & svg path {
                fill: ${themeGrey.disabled_grey};
            }
        }
    `
}
